import { default as activitiesl7YdVk20dwMeta } from "/root/code-vivasport/vs2-front/pages/activities.vue?macro=true";
import { default as _91id_93lnZnGy0NMNMeta } from "/root/code-vivasport/vs2-front/pages/chat/[id].vue?macro=true";
import { default as add_45friendsTrpSuaDP77Meta } from "/root/code-vivasport/vs2-front/pages/chat/add-friends.vue?macro=true";
import { default as create0vYUca3cBsMeta } from "/root/code-vivasport/vs2-front/pages/chat/create.vue?macro=true";
import { default as group_45membersdpchThDyKDMeta } from "/root/code-vivasport/vs2-front/pages/chat/group-members.vue?macro=true";
import { default as indexv3w1KVlRZOMeta } from "/root/code-vivasport/vs2-front/pages/chat/index.vue?macro=true";
import { default as class_45membersxzBxIJZtJAMeta } from "/root/code-vivasport/vs2-front/pages/class/[id]/class-members.vue?macro=true";
import { default as index9cCXM956U8Meta } from "/root/code-vivasport/vs2-front/pages/class/[id]/index.vue?macro=true";
import { default as reserve_45class_45informationUk9Dbfr3bPMeta } from "/root/code-vivasport/vs2-front/pages/class/[id]/reserve-class-information.vue?macro=true";
import { default as createmOZnwgmj0RMeta } from "/root/code-vivasport/vs2-front/pages/class/create.vue?macro=true";
import { default as gym_45listCBquAtxMKSMeta } from "/root/code-vivasport/vs2-front/pages/class/gym-list.vue?macro=true";
import { default as indexiM3HxuMTqNMeta } from "/root/code-vivasport/vs2-front/pages/class/index.vue?macro=true";
import { default as infoLQb4telHisMeta } from "/root/code-vivasport/vs2-front/pages/class/info.vue?macro=true";
import { default as listMHRVr2LX9rMeta } from "/root/code-vivasport/vs2-front/pages/class/list.vue?macro=true";
import { default as reservedSAIiuB7DGWMeta } from "/root/code-vivasport/vs2-front/pages/class/reserved.vue?macro=true";
import { default as academySDbZKk3OHPMeta } from "/root/code-vivasport/vs2-front/pages/club/[id]/academy.vue?macro=true";
import { default as indexZoKT4nsfpSMeta } from "/root/code-vivasport/vs2-front/pages/club/[id]/index.vue?macro=true";
import { default as leagues1LjjD1bGYHMeta } from "/root/code-vivasport/vs2-front/pages/club/[id]/leagues.vue?macro=true";
import { default as reserveScm7Avw9F9Meta } from "/root/code-vivasport/vs2-front/pages/club/[id]/reserve.vue?macro=true";
import { default as _91id_93GRNGUColqvMeta } from "/root/code-vivasport/vs2-front/pages/club/[id].vue?macro=true";
import { default as indexh7uLIuMPGuMeta } from "/root/code-vivasport/vs2-front/pages/club/index.vue?macro=true";
import { default as add_45comment0HnSkdUGM4Meta } from "/root/code-vivasport/vs2-front/pages/club/reserved/[id]/add-comment.vue?macro=true";
import { default as commentsIcBIRmLiWuMeta } from "/root/code-vivasport/vs2-front/pages/club/reserved/[id]/comments.vue?macro=true";
import { default as indexQAOk3ZoPidMeta } from "/root/code-vivasport/vs2-front/pages/club/reserved/[id]/index.vue?macro=true";
import { default as league_45detailsO7JDnBhBNMMeta } from "/root/code-vivasport/vs2-front/pages/club/reserved/[id]/league-details.vue?macro=true";
import { default as league_45teamsdv4fVUoEG9Meta } from "/root/code-vivasport/vs2-front/pages/club/reserved/[id]/league-teams.vue?macro=true";
import { default as addFriendsOGFwwRQQIDMeta } from "/root/code-vivasport/vs2-front/pages/club/reserved/[id]/reserve-gym/addFriends.vue?macro=true";
import { default as indexqDGd4laUuJMeta } from "/root/code-vivasport/vs2-front/pages/club/reserved/[id]/reserve-gym/index.vue?macro=true";
import { default as matchInformationOQsVCn0ELqMeta } from "/root/code-vivasport/vs2-front/pages/club/reserved/[id]/reserve-gym/matchInformation.vue?macro=true";
import { default as selectTeampqnU2pjSFrMeta } from "/root/code-vivasport/vs2-front/pages/club/reserved/[id]/reserve-gym/selectTeam.vue?macro=true";
import { default as selectTypeOoUGXV0gYTMeta } from "/root/code-vivasport/vs2-front/pages/club/reserved/[id]/reserve-gym/selectType.vue?macro=true";
import { default as indexKFLQywMIncMeta } from "/root/code-vivasport/vs2-front/pages/club/reserved/index.vue?macro=true";
import { default as indextDmGelLjX2Meta } from "/root/code-vivasport/vs2-front/pages/competitions/index.vue?macro=true";
import { default as indexJ6TikXaHaiMeta } from "/root/code-vivasport/vs2-front/pages/index.vue?macro=true";
import { default as index1JYLhJgSMFMeta } from "/root/code-vivasport/vs2-front/pages/leagues/[id]/index.vue?macro=true";
import { default as create0KVcRnxX56Meta } from "/root/code-vivasport/vs2-front/pages/leagues/create.vue?macro=true";
import { default as index9Abhd4497LMeta } from "/root/code-vivasport/vs2-front/pages/leagues/index.vue?macro=true";
import { default as _91id_93YEO2LZTOWZMeta } from "/root/code-vivasport/vs2-front/pages/lig/[id].vue?macro=true";
import { default as add_45friend3BUtnVHekbMeta } from "/root/code-vivasport/vs2-front/pages/lig/add-friend.vue?macro=true";
import { default as checkoutSpQPkZzLV0Meta } from "/root/code-vivasport/vs2-front/pages/lig/checkout.vue?macro=true";
import { default as createZ0oUN0LowpMeta } from "/root/code-vivasport/vs2-front/pages/lig/create.vue?macro=true";
import { default as indexb3SoWXdH1KMeta } from "/root/code-vivasport/vs2-front/pages/lig/index.vue?macro=true";
import { default as listAwqeHo2DBvMeta } from "/root/code-vivasport/vs2-front/pages/lig/list.vue?macro=true";
import { default as select_45gymosDcMUlth3Meta } from "/root/code-vivasport/vs2-front/pages/lig/select-gym.vue?macro=true";
import { default as select_45teamz20hEMqXdmMeta } from "/root/code-vivasport/vs2-front/pages/lig/select-team.vue?macro=true";
import { default as index2kvo6DtMnOMeta } from "/root/code-vivasport/vs2-front/pages/login/index.vue?macro=true";
import { default as otpuNxa5NWVt8Meta } from "/root/code-vivasport/vs2-front/pages/login/otp.vue?macro=true";
import { default as _91id_93V3BwTEPky3Meta } from "/root/code-vivasport/vs2-front/pages/match/[id].vue?macro=true";
import { default as indexsyxwMBFXdtMeta } from "/root/code-vivasport/vs2-front/pages/match/index.vue?macro=true";
import { default as requestZ9PyV5Rg6tMeta } from "/root/code-vivasport/vs2-front/pages/match/request.vue?macro=true";
import { default as resultvIRxZPXKm9Meta } from "/root/code-vivasport/vs2-front/pages/match/result.vue?macro=true";
import { default as _91id_93_46edithyEDQMTyyDMeta } from "/root/code-vivasport/vs2-front/pages/matches/[id].edit.vue?macro=true";
import { default as editblBqNUTTrFMeta } from "/root/code-vivasport/vs2-front/pages/matches/[id]/edit.vue?macro=true";
import { default as indextYc3qvNmlcMeta } from "/root/code-vivasport/vs2-front/pages/matches/[id]/index.vue?macro=true";
import { default as _91id_93A10e2Ev732Meta } from "/root/code-vivasport/vs2-front/pages/matches/[id].vue?macro=true";
import { default as createtbdJu1tjniMeta } from "/root/code-vivasport/vs2-front/pages/matches/create.vue?macro=true";
import { default as indexprwA5j3expMeta } from "/root/code-vivasport/vs2-front/pages/matches/index.vue?macro=true";
import { default as _91code_933YsrNi88gzMeta } from "/root/code-vivasport/vs2-front/pages/matches/invite/[code].vue?macro=true";
import { default as _91id_93yYaf81YY5iMeta } from "/root/code-vivasport/vs2-front/pages/notifications/[id].vue?macro=true";
import { default as indexrQzUTyyGEJMeta } from "/root/code-vivasport/vs2-front/pages/notifications/index.vue?macro=true";
import { default as _91id_93MnX7G4F5RlMeta } from "/root/code-vivasport/vs2-front/pages/profile/[id].vue?macro=true";
import { default as coach_45authenticationkQ8f3rOOsYMeta } from "/root/code-vivasport/vs2-front/pages/profile/coach-authentication.vue?macro=true";
import { default as followersoBmxiYOW1MMeta } from "/root/code-vivasport/vs2-front/pages/profile/followers.vue?macro=true";
import { default as indexWZoDBNRNRHMeta } from "/root/code-vivasport/vs2-front/pages/profile/index.vue?macro=true";
import { default as infowbCA5MFiflMeta } from "/root/code-vivasport/vs2-front/pages/profile/info.vue?macro=true";
import { default as matchsAhltSRTMEFMeta } from "/root/code-vivasport/vs2-front/pages/profile/matchs.vue?macro=true";
import { default as new_45passwordYJ4tgj64ZSMeta } from "/root/code-vivasport/vs2-front/pages/profile/new-password.vue?macro=true";
import { default as otprL2bSitB2nMeta } from "/root/code-vivasport/vs2-front/pages/profile/otp.vue?macro=true";
import { default as ranking4fsDlES2aCMeta } from "/root/code-vivasport/vs2-front/pages/profile/ranking.vue?macro=true";
import { default as skillslyMZdQ6TDuMeta } from "/root/code-vivasport/vs2-front/pages/profile/skills.vue?macro=true";
import { default as depositlL3XOnkAzsMeta } from "/root/code-vivasport/vs2-front/pages/profile/wallet/deposit.vue?macro=true";
import { default as indext2J67Kj8odMeta } from "/root/code-vivasport/vs2-front/pages/profile/wallet/index.vue?macro=true";
import { default as withdrawCQWYAEluB5Meta } from "/root/code-vivasport/vs2-front/pages/profile/wallet/withdraw.vue?macro=true";
import { default as walletYAjdI0tneoMeta } from "/root/code-vivasport/vs2-front/pages/profile/wallet.vue?macro=true";
import { default as rating54VieAwEvzMeta } from "/root/code-vivasport/vs2-front/pages/rating.vue?macro=true";
import { default as completecSHDNTfBClMeta } from "/root/code-vivasport/vs2-front/pages/register/complete.vue?macro=true";
import { default as indexuGffYS8rNDMeta } from "/root/code-vivasport/vs2-front/pages/register/index.vue?macro=true";
import { default as levelingeQupbBdjOHMeta } from "/root/code-vivasport/vs2-front/pages/register/leveling.vue?macro=true";
import { default as otpKgKEWoI08FMeta } from "/root/code-vivasport/vs2-front/pages/register/otp.vue?macro=true";
import { default as select_45sportQaQNzSsJD6Meta } from "/root/code-vivasport/vs2-front/pages/register/select-sport.vue?macro=true";
import { default as reset_45passwordJ9ZgVuvK60Meta } from "/root/code-vivasport/vs2-front/pages/reset-password.vue?macro=true";
import { default as add8StPDfLLU0Meta } from "/root/code-vivasport/vs2-front/pages/socials/[id]/comments/add.vue?macro=true";
import { default as indexhuLsXQ3bwJMeta } from "/root/code-vivasport/vs2-front/pages/socials/[id]/comments/index.vue?macro=true";
import { default as add_45postExwoq7JM7sMeta } from "/root/code-vivasport/vs2-front/pages/socials/add-post.vue?macro=true";
import { default as indexZFgJj3oZIqMeta } from "/root/code-vivasport/vs2-front/pages/socials/index.vue?macro=true";
import { default as profilesOSBfcd534eMeta } from "/root/code-vivasport/vs2-front/pages/socials/profiles.vue?macro=true";
import { default as index0UyGoXICNeMeta } from "/root/code-vivasport/vs2-front/pages/tournaments/[id]/index.vue?macro=true";
import { default as indexD2gbiC755jMeta } from "/root/code-vivasport/vs2-front/pages/tournaments/index.vue?macro=true";
export default [
  {
    name: activitiesl7YdVk20dwMeta?.name ?? "activities",
    path: activitiesl7YdVk20dwMeta?.path ?? "/activities",
    meta: activitiesl7YdVk20dwMeta || {},
    alias: activitiesl7YdVk20dwMeta?.alias || [],
    redirect: activitiesl7YdVk20dwMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/activities.vue").then(m => m.default || m)
  },
  {
    name: _91id_93lnZnGy0NMNMeta?.name ?? "chat-id",
    path: _91id_93lnZnGy0NMNMeta?.path ?? "/chat/:id()",
    meta: _91id_93lnZnGy0NMNMeta || {},
    alias: _91id_93lnZnGy0NMNMeta?.alias || [],
    redirect: _91id_93lnZnGy0NMNMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/chat/[id].vue").then(m => m.default || m)
  },
  {
    name: add_45friendsTrpSuaDP77Meta?.name ?? "chat-add-friends",
    path: add_45friendsTrpSuaDP77Meta?.path ?? "/chat/add-friends",
    meta: add_45friendsTrpSuaDP77Meta || {},
    alias: add_45friendsTrpSuaDP77Meta?.alias || [],
    redirect: add_45friendsTrpSuaDP77Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/chat/add-friends.vue").then(m => m.default || m)
  },
  {
    name: create0vYUca3cBsMeta?.name ?? "chat-create",
    path: create0vYUca3cBsMeta?.path ?? "/chat/create",
    meta: create0vYUca3cBsMeta || {},
    alias: create0vYUca3cBsMeta?.alias || [],
    redirect: create0vYUca3cBsMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/chat/create.vue").then(m => m.default || m)
  },
  {
    name: group_45membersdpchThDyKDMeta?.name ?? "chat-group-members",
    path: group_45membersdpchThDyKDMeta?.path ?? "/chat/group-members",
    meta: group_45membersdpchThDyKDMeta || {},
    alias: group_45membersdpchThDyKDMeta?.alias || [],
    redirect: group_45membersdpchThDyKDMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/chat/group-members.vue").then(m => m.default || m)
  },
  {
    name: indexv3w1KVlRZOMeta?.name ?? "chat",
    path: indexv3w1KVlRZOMeta?.path ?? "/chat",
    meta: indexv3w1KVlRZOMeta || {},
    alias: indexv3w1KVlRZOMeta?.alias || [],
    redirect: indexv3w1KVlRZOMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/chat/index.vue").then(m => m.default || m)
  },
  {
    name: class_45membersxzBxIJZtJAMeta?.name ?? "class-id-class-members",
    path: class_45membersxzBxIJZtJAMeta?.path ?? "/class/:id()/class-members",
    meta: class_45membersxzBxIJZtJAMeta || {},
    alias: class_45membersxzBxIJZtJAMeta?.alias || [],
    redirect: class_45membersxzBxIJZtJAMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/class/[id]/class-members.vue").then(m => m.default || m)
  },
  {
    name: index9cCXM956U8Meta?.name ?? "class-id",
    path: index9cCXM956U8Meta?.path ?? "/class/:id()",
    meta: index9cCXM956U8Meta || {},
    alias: index9cCXM956U8Meta?.alias || [],
    redirect: index9cCXM956U8Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/class/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: reserve_45class_45informationUk9Dbfr3bPMeta?.name ?? "class-id-reserve-class-information",
    path: reserve_45class_45informationUk9Dbfr3bPMeta?.path ?? "/class/:id()/reserve-class-information",
    meta: reserve_45class_45informationUk9Dbfr3bPMeta || {},
    alias: reserve_45class_45informationUk9Dbfr3bPMeta?.alias || [],
    redirect: reserve_45class_45informationUk9Dbfr3bPMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/class/[id]/reserve-class-information.vue").then(m => m.default || m)
  },
  {
    name: createmOZnwgmj0RMeta?.name ?? "class-create",
    path: createmOZnwgmj0RMeta?.path ?? "/class/create",
    meta: createmOZnwgmj0RMeta || {},
    alias: createmOZnwgmj0RMeta?.alias || [],
    redirect: createmOZnwgmj0RMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/class/create.vue").then(m => m.default || m)
  },
  {
    name: gym_45listCBquAtxMKSMeta?.name ?? "class-gym-list",
    path: gym_45listCBquAtxMKSMeta?.path ?? "/class/gym-list",
    meta: gym_45listCBquAtxMKSMeta || {},
    alias: gym_45listCBquAtxMKSMeta?.alias || [],
    redirect: gym_45listCBquAtxMKSMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/class/gym-list.vue").then(m => m.default || m)
  },
  {
    name: indexiM3HxuMTqNMeta?.name ?? "class",
    path: indexiM3HxuMTqNMeta?.path ?? "/class",
    meta: indexiM3HxuMTqNMeta || {},
    alias: indexiM3HxuMTqNMeta?.alias || [],
    redirect: indexiM3HxuMTqNMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/class/index.vue").then(m => m.default || m)
  },
  {
    name: infoLQb4telHisMeta?.name ?? "class-info",
    path: infoLQb4telHisMeta?.path ?? "/class/info",
    meta: infoLQb4telHisMeta || {},
    alias: infoLQb4telHisMeta?.alias || [],
    redirect: infoLQb4telHisMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/class/info.vue").then(m => m.default || m)
  },
  {
    name: listMHRVr2LX9rMeta?.name ?? "class-list",
    path: listMHRVr2LX9rMeta?.path ?? "/class/list",
    meta: listMHRVr2LX9rMeta || {},
    alias: listMHRVr2LX9rMeta?.alias || [],
    redirect: listMHRVr2LX9rMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/class/list.vue").then(m => m.default || m)
  },
  {
    name: reservedSAIiuB7DGWMeta?.name ?? "class-reserved",
    path: reservedSAIiuB7DGWMeta?.path ?? "/class/reserved",
    meta: reservedSAIiuB7DGWMeta || {},
    alias: reservedSAIiuB7DGWMeta?.alias || [],
    redirect: reservedSAIiuB7DGWMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/class/reserved.vue").then(m => m.default || m)
  },
  {
    name: _91id_93GRNGUColqvMeta?.name ?? undefined,
    path: _91id_93GRNGUColqvMeta?.path ?? "/club/:id()",
    meta: _91id_93GRNGUColqvMeta || {},
    alias: _91id_93GRNGUColqvMeta?.alias || [],
    redirect: _91id_93GRNGUColqvMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/[id].vue").then(m => m.default || m),
    children: [
  {
    name: academySDbZKk3OHPMeta?.name ?? "club-id-academy",
    path: academySDbZKk3OHPMeta?.path ?? "academy",
    meta: academySDbZKk3OHPMeta || {},
    alias: academySDbZKk3OHPMeta?.alias || [],
    redirect: academySDbZKk3OHPMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/[id]/academy.vue").then(m => m.default || m)
  },
  {
    name: indexZoKT4nsfpSMeta?.name ?? "club-id",
    path: indexZoKT4nsfpSMeta?.path ?? "",
    meta: indexZoKT4nsfpSMeta || {},
    alias: indexZoKT4nsfpSMeta?.alias || [],
    redirect: indexZoKT4nsfpSMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: leagues1LjjD1bGYHMeta?.name ?? "club-id-leagues",
    path: leagues1LjjD1bGYHMeta?.path ?? "leagues",
    meta: leagues1LjjD1bGYHMeta || {},
    alias: leagues1LjjD1bGYHMeta?.alias || [],
    redirect: leagues1LjjD1bGYHMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/[id]/leagues.vue").then(m => m.default || m)
  },
  {
    name: reserveScm7Avw9F9Meta?.name ?? "club-id-reserve",
    path: reserveScm7Avw9F9Meta?.path ?? "reserve",
    meta: reserveScm7Avw9F9Meta || {},
    alias: reserveScm7Avw9F9Meta?.alias || [],
    redirect: reserveScm7Avw9F9Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/[id]/reserve.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexh7uLIuMPGuMeta?.name ?? "club",
    path: indexh7uLIuMPGuMeta?.path ?? "/club",
    meta: indexh7uLIuMPGuMeta || {},
    alias: indexh7uLIuMPGuMeta?.alias || [],
    redirect: indexh7uLIuMPGuMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/index.vue").then(m => m.default || m)
  },
  {
    name: add_45comment0HnSkdUGM4Meta?.name ?? "club-reserved-id-add-comment",
    path: add_45comment0HnSkdUGM4Meta?.path ?? "/club/reserved/:id()/add-comment",
    meta: add_45comment0HnSkdUGM4Meta || {},
    alias: add_45comment0HnSkdUGM4Meta?.alias || [],
    redirect: add_45comment0HnSkdUGM4Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/[id]/add-comment.vue").then(m => m.default || m)
  },
  {
    name: commentsIcBIRmLiWuMeta?.name ?? "club-reserved-id-comments",
    path: commentsIcBIRmLiWuMeta?.path ?? "/club/reserved/:id()/comments",
    meta: commentsIcBIRmLiWuMeta || {},
    alias: commentsIcBIRmLiWuMeta?.alias || [],
    redirect: commentsIcBIRmLiWuMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/[id]/comments.vue").then(m => m.default || m)
  },
  {
    name: indexQAOk3ZoPidMeta?.name ?? "club-reserved-id",
    path: indexQAOk3ZoPidMeta?.path ?? "/club/reserved/:id()",
    meta: indexQAOk3ZoPidMeta || {},
    alias: indexQAOk3ZoPidMeta?.alias || [],
    redirect: indexQAOk3ZoPidMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: league_45detailsO7JDnBhBNMMeta?.name ?? "club-reserved-id-league-details",
    path: league_45detailsO7JDnBhBNMMeta?.path ?? "/club/reserved/:id()/league-details",
    meta: league_45detailsO7JDnBhBNMMeta || {},
    alias: league_45detailsO7JDnBhBNMMeta?.alias || [],
    redirect: league_45detailsO7JDnBhBNMMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/[id]/league-details.vue").then(m => m.default || m)
  },
  {
    name: league_45teamsdv4fVUoEG9Meta?.name ?? "club-reserved-id-league-teams",
    path: league_45teamsdv4fVUoEG9Meta?.path ?? "/club/reserved/:id()/league-teams",
    meta: league_45teamsdv4fVUoEG9Meta || {},
    alias: league_45teamsdv4fVUoEG9Meta?.alias || [],
    redirect: league_45teamsdv4fVUoEG9Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/[id]/league-teams.vue").then(m => m.default || m)
  },
  {
    name: addFriendsOGFwwRQQIDMeta?.name ?? "club-reserved-id-reserve-gym-addFriends",
    path: addFriendsOGFwwRQQIDMeta?.path ?? "/club/reserved/:id()/reserve-gym/addFriends",
    meta: addFriendsOGFwwRQQIDMeta || {},
    alias: addFriendsOGFwwRQQIDMeta?.alias || [],
    redirect: addFriendsOGFwwRQQIDMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/[id]/reserve-gym/addFriends.vue").then(m => m.default || m)
  },
  {
    name: indexqDGd4laUuJMeta?.name ?? "club-reserved-id-reserve-gym",
    path: indexqDGd4laUuJMeta?.path ?? "/club/reserved/:id()/reserve-gym",
    meta: indexqDGd4laUuJMeta || {},
    alias: indexqDGd4laUuJMeta?.alias || [],
    redirect: indexqDGd4laUuJMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/[id]/reserve-gym/index.vue").then(m => m.default || m)
  },
  {
    name: matchInformationOQsVCn0ELqMeta?.name ?? "club-reserved-id-reserve-gym-matchInformation",
    path: matchInformationOQsVCn0ELqMeta?.path ?? "/club/reserved/:id()/reserve-gym/matchInformation",
    meta: matchInformationOQsVCn0ELqMeta || {},
    alias: matchInformationOQsVCn0ELqMeta?.alias || [],
    redirect: matchInformationOQsVCn0ELqMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/[id]/reserve-gym/matchInformation.vue").then(m => m.default || m)
  },
  {
    name: selectTeampqnU2pjSFrMeta?.name ?? "club-reserved-id-reserve-gym-selectTeam",
    path: selectTeampqnU2pjSFrMeta?.path ?? "/club/reserved/:id()/reserve-gym/selectTeam",
    meta: selectTeampqnU2pjSFrMeta || {},
    alias: selectTeampqnU2pjSFrMeta?.alias || [],
    redirect: selectTeampqnU2pjSFrMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/[id]/reserve-gym/selectTeam.vue").then(m => m.default || m)
  },
  {
    name: selectTypeOoUGXV0gYTMeta?.name ?? "club-reserved-id-reserve-gym-selectType",
    path: selectTypeOoUGXV0gYTMeta?.path ?? "/club/reserved/:id()/reserve-gym/selectType",
    meta: selectTypeOoUGXV0gYTMeta || {},
    alias: selectTypeOoUGXV0gYTMeta?.alias || [],
    redirect: selectTypeOoUGXV0gYTMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/[id]/reserve-gym/selectType.vue").then(m => m.default || m)
  },
  {
    name: indexKFLQywMIncMeta?.name ?? "club-reserved",
    path: indexKFLQywMIncMeta?.path ?? "/club/reserved",
    meta: indexKFLQywMIncMeta || {},
    alias: indexKFLQywMIncMeta?.alias || [],
    redirect: indexKFLQywMIncMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/club/reserved/index.vue").then(m => m.default || m)
  },
  {
    name: indextDmGelLjX2Meta?.name ?? "competitions",
    path: indextDmGelLjX2Meta?.path ?? "/competitions",
    meta: indextDmGelLjX2Meta || {},
    alias: indextDmGelLjX2Meta?.alias || [],
    redirect: indextDmGelLjX2Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/competitions/index.vue").then(m => m.default || m)
  },
  {
    name: indexJ6TikXaHaiMeta?.name ?? "index",
    path: indexJ6TikXaHaiMeta?.path ?? "/",
    meta: indexJ6TikXaHaiMeta || {},
    alias: indexJ6TikXaHaiMeta?.alias || [],
    redirect: indexJ6TikXaHaiMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index1JYLhJgSMFMeta?.name ?? "leagues-id",
    path: index1JYLhJgSMFMeta?.path ?? "/leagues/:id()",
    meta: index1JYLhJgSMFMeta || {},
    alias: index1JYLhJgSMFMeta?.alias || [],
    redirect: index1JYLhJgSMFMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/leagues/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: create0KVcRnxX56Meta?.name ?? "leagues-create",
    path: create0KVcRnxX56Meta?.path ?? "/leagues/create",
    meta: create0KVcRnxX56Meta || {},
    alias: create0KVcRnxX56Meta?.alias || [],
    redirect: create0KVcRnxX56Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/leagues/create.vue").then(m => m.default || m)
  },
  {
    name: index9Abhd4497LMeta?.name ?? "leagues",
    path: index9Abhd4497LMeta?.path ?? "/leagues",
    meta: index9Abhd4497LMeta || {},
    alias: index9Abhd4497LMeta?.alias || [],
    redirect: index9Abhd4497LMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/leagues/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93YEO2LZTOWZMeta?.name ?? "lig-id",
    path: _91id_93YEO2LZTOWZMeta?.path ?? "/lig/:id()",
    meta: _91id_93YEO2LZTOWZMeta || {},
    alias: _91id_93YEO2LZTOWZMeta?.alias || [],
    redirect: _91id_93YEO2LZTOWZMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/lig/[id].vue").then(m => m.default || m)
  },
  {
    name: add_45friend3BUtnVHekbMeta?.name ?? "lig-add-friend",
    path: add_45friend3BUtnVHekbMeta?.path ?? "/lig/add-friend",
    meta: add_45friend3BUtnVHekbMeta || {},
    alias: add_45friend3BUtnVHekbMeta?.alias || [],
    redirect: add_45friend3BUtnVHekbMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/lig/add-friend.vue").then(m => m.default || m)
  },
  {
    name: checkoutSpQPkZzLV0Meta?.name ?? "lig-checkout",
    path: checkoutSpQPkZzLV0Meta?.path ?? "/lig/checkout",
    meta: checkoutSpQPkZzLV0Meta || {},
    alias: checkoutSpQPkZzLV0Meta?.alias || [],
    redirect: checkoutSpQPkZzLV0Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/lig/checkout.vue").then(m => m.default || m)
  },
  {
    name: createZ0oUN0LowpMeta?.name ?? "lig-create",
    path: createZ0oUN0LowpMeta?.path ?? "/lig/create",
    meta: createZ0oUN0LowpMeta || {},
    alias: createZ0oUN0LowpMeta?.alias || [],
    redirect: createZ0oUN0LowpMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/lig/create.vue").then(m => m.default || m)
  },
  {
    name: indexb3SoWXdH1KMeta?.name ?? "lig",
    path: indexb3SoWXdH1KMeta?.path ?? "/lig",
    meta: indexb3SoWXdH1KMeta || {},
    alias: indexb3SoWXdH1KMeta?.alias || [],
    redirect: indexb3SoWXdH1KMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/lig/index.vue").then(m => m.default || m)
  },
  {
    name: listAwqeHo2DBvMeta?.name ?? "lig-list",
    path: listAwqeHo2DBvMeta?.path ?? "/lig/list",
    meta: listAwqeHo2DBvMeta || {},
    alias: listAwqeHo2DBvMeta?.alias || [],
    redirect: listAwqeHo2DBvMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/lig/list.vue").then(m => m.default || m)
  },
  {
    name: select_45gymosDcMUlth3Meta?.name ?? "lig-select-gym",
    path: select_45gymosDcMUlth3Meta?.path ?? "/lig/select-gym",
    meta: select_45gymosDcMUlth3Meta || {},
    alias: select_45gymosDcMUlth3Meta?.alias || [],
    redirect: select_45gymosDcMUlth3Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/lig/select-gym.vue").then(m => m.default || m)
  },
  {
    name: select_45teamz20hEMqXdmMeta?.name ?? "lig-select-team",
    path: select_45teamz20hEMqXdmMeta?.path ?? "/lig/select-team",
    meta: select_45teamz20hEMqXdmMeta || {},
    alias: select_45teamz20hEMqXdmMeta?.alias || [],
    redirect: select_45teamz20hEMqXdmMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/lig/select-team.vue").then(m => m.default || m)
  },
  {
    name: index2kvo6DtMnOMeta?.name ?? "login",
    path: index2kvo6DtMnOMeta?.path ?? "/login",
    meta: index2kvo6DtMnOMeta || {},
    alias: index2kvo6DtMnOMeta?.alias || [],
    redirect: index2kvo6DtMnOMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: otpuNxa5NWVt8Meta?.name ?? "login-otp",
    path: otpuNxa5NWVt8Meta?.path ?? "/login/otp",
    meta: otpuNxa5NWVt8Meta || {},
    alias: otpuNxa5NWVt8Meta?.alias || [],
    redirect: otpuNxa5NWVt8Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/login/otp.vue").then(m => m.default || m)
  },
  {
    name: _91id_93V3BwTEPky3Meta?.name ?? "match-id",
    path: _91id_93V3BwTEPky3Meta?.path ?? "/match/:id()",
    meta: _91id_93V3BwTEPky3Meta || {},
    alias: _91id_93V3BwTEPky3Meta?.alias || [],
    redirect: _91id_93V3BwTEPky3Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/match/[id].vue").then(m => m.default || m)
  },
  {
    name: indexsyxwMBFXdtMeta?.name ?? "match",
    path: indexsyxwMBFXdtMeta?.path ?? "/match",
    meta: indexsyxwMBFXdtMeta || {},
    alias: indexsyxwMBFXdtMeta?.alias || [],
    redirect: indexsyxwMBFXdtMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/match/index.vue").then(m => m.default || m)
  },
  {
    name: requestZ9PyV5Rg6tMeta?.name ?? "match-request",
    path: requestZ9PyV5Rg6tMeta?.path ?? "/match/request",
    meta: requestZ9PyV5Rg6tMeta || {},
    alias: requestZ9PyV5Rg6tMeta?.alias || [],
    redirect: requestZ9PyV5Rg6tMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/match/request.vue").then(m => m.default || m)
  },
  {
    name: resultvIRxZPXKm9Meta?.name ?? "match-result",
    path: resultvIRxZPXKm9Meta?.path ?? "/match/result",
    meta: resultvIRxZPXKm9Meta || {},
    alias: resultvIRxZPXKm9Meta?.alias || [],
    redirect: resultvIRxZPXKm9Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/match/result.vue").then(m => m.default || m)
  },
  {
    name: _91id_93_46edithyEDQMTyyDMeta?.name ?? "matches-id.edit",
    path: _91id_93_46edithyEDQMTyyDMeta?.path ?? "/matches/:id().edit",
    meta: _91id_93_46edithyEDQMTyyDMeta || {},
    alias: _91id_93_46edithyEDQMTyyDMeta?.alias || [],
    redirect: _91id_93_46edithyEDQMTyyDMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/matches/[id].edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93A10e2Ev732Meta?.name ?? undefined,
    path: _91id_93A10e2Ev732Meta?.path ?? "/matches/:id()",
    meta: _91id_93A10e2Ev732Meta || {},
    alias: _91id_93A10e2Ev732Meta?.alias || [],
    redirect: _91id_93A10e2Ev732Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/matches/[id].vue").then(m => m.default || m),
    children: [
  {
    name: editblBqNUTTrFMeta?.name ?? "matches-id-edit",
    path: editblBqNUTTrFMeta?.path ?? "edit",
    meta: editblBqNUTTrFMeta || {},
    alias: editblBqNUTTrFMeta?.alias || [],
    redirect: editblBqNUTTrFMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/matches/[id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indextYc3qvNmlcMeta?.name ?? "matches-id",
    path: indextYc3qvNmlcMeta?.path ?? "",
    meta: indextYc3qvNmlcMeta || {},
    alias: indextYc3qvNmlcMeta?.alias || [],
    redirect: indextYc3qvNmlcMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/matches/[id]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: createtbdJu1tjniMeta?.name ?? "matches-create",
    path: createtbdJu1tjniMeta?.path ?? "/matches/create",
    meta: createtbdJu1tjniMeta || {},
    alias: createtbdJu1tjniMeta?.alias || [],
    redirect: createtbdJu1tjniMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/matches/create.vue").then(m => m.default || m)
  },
  {
    name: indexprwA5j3expMeta?.name ?? "matches",
    path: indexprwA5j3expMeta?.path ?? "/matches",
    meta: indexprwA5j3expMeta || {},
    alias: indexprwA5j3expMeta?.alias || [],
    redirect: indexprwA5j3expMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/matches/index.vue").then(m => m.default || m)
  },
  {
    name: _91code_933YsrNi88gzMeta?.name ?? "matches-invite-code",
    path: _91code_933YsrNi88gzMeta?.path ?? "/matches/invite/:code()",
    meta: _91code_933YsrNi88gzMeta || {},
    alias: _91code_933YsrNi88gzMeta?.alias || [],
    redirect: _91code_933YsrNi88gzMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/matches/invite/[code].vue").then(m => m.default || m)
  },
  {
    name: _91id_93yYaf81YY5iMeta?.name ?? "notifications-id",
    path: _91id_93yYaf81YY5iMeta?.path ?? "/notifications/:id()",
    meta: _91id_93yYaf81YY5iMeta || {},
    alias: _91id_93yYaf81YY5iMeta?.alias || [],
    redirect: _91id_93yYaf81YY5iMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/notifications/[id].vue").then(m => m.default || m)
  },
  {
    name: indexrQzUTyyGEJMeta?.name ?? "notifications",
    path: indexrQzUTyyGEJMeta?.path ?? "/notifications",
    meta: indexrQzUTyyGEJMeta || {},
    alias: indexrQzUTyyGEJMeta?.alias || [],
    redirect: indexrQzUTyyGEJMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/notifications/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93MnX7G4F5RlMeta?.name ?? "profile-id",
    path: _91id_93MnX7G4F5RlMeta?.path ?? "/profile/:id()",
    meta: _91id_93MnX7G4F5RlMeta || {},
    alias: _91id_93MnX7G4F5RlMeta?.alias || [],
    redirect: _91id_93MnX7G4F5RlMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/[id].vue").then(m => m.default || m)
  },
  {
    name: coach_45authenticationkQ8f3rOOsYMeta?.name ?? "profile-coach-authentication",
    path: coach_45authenticationkQ8f3rOOsYMeta?.path ?? "/profile/coach-authentication",
    meta: coach_45authenticationkQ8f3rOOsYMeta || {},
    alias: coach_45authenticationkQ8f3rOOsYMeta?.alias || [],
    redirect: coach_45authenticationkQ8f3rOOsYMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/coach-authentication.vue").then(m => m.default || m)
  },
  {
    name: followersoBmxiYOW1MMeta?.name ?? "profile-followers",
    path: followersoBmxiYOW1MMeta?.path ?? "/profile/followers",
    meta: followersoBmxiYOW1MMeta || {},
    alias: followersoBmxiYOW1MMeta?.alias || [],
    redirect: followersoBmxiYOW1MMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/followers.vue").then(m => m.default || m)
  },
  {
    name: indexWZoDBNRNRHMeta?.name ?? "profile",
    path: indexWZoDBNRNRHMeta?.path ?? "/profile",
    meta: indexWZoDBNRNRHMeta || {},
    alias: indexWZoDBNRNRHMeta?.alias || [],
    redirect: indexWZoDBNRNRHMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: infowbCA5MFiflMeta?.name ?? "profile-info",
    path: infowbCA5MFiflMeta?.path ?? "/profile/info",
    meta: infowbCA5MFiflMeta || {},
    alias: infowbCA5MFiflMeta?.alias || [],
    redirect: infowbCA5MFiflMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/info.vue").then(m => m.default || m)
  },
  {
    name: matchsAhltSRTMEFMeta?.name ?? "profile-matchs",
    path: matchsAhltSRTMEFMeta?.path ?? "/profile/matchs",
    meta: matchsAhltSRTMEFMeta || {},
    alias: matchsAhltSRTMEFMeta?.alias || [],
    redirect: matchsAhltSRTMEFMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/matchs.vue").then(m => m.default || m)
  },
  {
    name: new_45passwordYJ4tgj64ZSMeta?.name ?? "profile-new-password",
    path: new_45passwordYJ4tgj64ZSMeta?.path ?? "/profile/new-password",
    meta: new_45passwordYJ4tgj64ZSMeta || {},
    alias: new_45passwordYJ4tgj64ZSMeta?.alias || [],
    redirect: new_45passwordYJ4tgj64ZSMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/new-password.vue").then(m => m.default || m)
  },
  {
    name: otprL2bSitB2nMeta?.name ?? "profile-otp",
    path: otprL2bSitB2nMeta?.path ?? "/profile/otp",
    meta: otprL2bSitB2nMeta || {},
    alias: otprL2bSitB2nMeta?.alias || [],
    redirect: otprL2bSitB2nMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/otp.vue").then(m => m.default || m)
  },
  {
    name: ranking4fsDlES2aCMeta?.name ?? "profile-ranking",
    path: ranking4fsDlES2aCMeta?.path ?? "/profile/ranking",
    meta: ranking4fsDlES2aCMeta || {},
    alias: ranking4fsDlES2aCMeta?.alias || [],
    redirect: ranking4fsDlES2aCMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/ranking.vue").then(m => m.default || m)
  },
  {
    name: skillslyMZdQ6TDuMeta?.name ?? "profile-skills",
    path: skillslyMZdQ6TDuMeta?.path ?? "/profile/skills",
    meta: skillslyMZdQ6TDuMeta || {},
    alias: skillslyMZdQ6TDuMeta?.alias || [],
    redirect: skillslyMZdQ6TDuMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/skills.vue").then(m => m.default || m)
  },
  {
    name: walletYAjdI0tneoMeta?.name ?? undefined,
    path: walletYAjdI0tneoMeta?.path ?? "/profile/wallet",
    meta: walletYAjdI0tneoMeta || {},
    alias: walletYAjdI0tneoMeta?.alias || [],
    redirect: walletYAjdI0tneoMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/wallet.vue").then(m => m.default || m),
    children: [
  {
    name: depositlL3XOnkAzsMeta?.name ?? "profile-wallet-deposit",
    path: depositlL3XOnkAzsMeta?.path ?? "deposit",
    meta: depositlL3XOnkAzsMeta || {},
    alias: depositlL3XOnkAzsMeta?.alias || [],
    redirect: depositlL3XOnkAzsMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/wallet/deposit.vue").then(m => m.default || m)
  },
  {
    name: indext2J67Kj8odMeta?.name ?? "profile-wallet",
    path: indext2J67Kj8odMeta?.path ?? "",
    meta: indext2J67Kj8odMeta || {},
    alias: indext2J67Kj8odMeta?.alias || [],
    redirect: indext2J67Kj8odMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: withdrawCQWYAEluB5Meta?.name ?? "profile-wallet-withdraw",
    path: withdrawCQWYAEluB5Meta?.path ?? "withdraw",
    meta: withdrawCQWYAEluB5Meta || {},
    alias: withdrawCQWYAEluB5Meta?.alias || [],
    redirect: withdrawCQWYAEluB5Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/profile/wallet/withdraw.vue").then(m => m.default || m)
  }
]
  },
  {
    name: rating54VieAwEvzMeta?.name ?? "rating",
    path: rating54VieAwEvzMeta?.path ?? "/rating",
    meta: rating54VieAwEvzMeta || {},
    alias: rating54VieAwEvzMeta?.alias || [],
    redirect: rating54VieAwEvzMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/rating.vue").then(m => m.default || m)
  },
  {
    name: completecSHDNTfBClMeta?.name ?? "register-complete",
    path: completecSHDNTfBClMeta?.path ?? "/register/complete",
    meta: completecSHDNTfBClMeta || {},
    alias: completecSHDNTfBClMeta?.alias || [],
    redirect: completecSHDNTfBClMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/register/complete.vue").then(m => m.default || m)
  },
  {
    name: indexuGffYS8rNDMeta?.name ?? "register",
    path: indexuGffYS8rNDMeta?.path ?? "/register",
    meta: indexuGffYS8rNDMeta || {},
    alias: indexuGffYS8rNDMeta?.alias || [],
    redirect: indexuGffYS8rNDMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/register/index.vue").then(m => m.default || m)
  },
  {
    name: levelingeQupbBdjOHMeta?.name ?? "register-leveling",
    path: levelingeQupbBdjOHMeta?.path ?? "/register/leveling",
    meta: levelingeQupbBdjOHMeta || {},
    alias: levelingeQupbBdjOHMeta?.alias || [],
    redirect: levelingeQupbBdjOHMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/register/leveling.vue").then(m => m.default || m)
  },
  {
    name: otpKgKEWoI08FMeta?.name ?? "register-otp",
    path: otpKgKEWoI08FMeta?.path ?? "/register/otp",
    meta: otpKgKEWoI08FMeta || {},
    alias: otpKgKEWoI08FMeta?.alias || [],
    redirect: otpKgKEWoI08FMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/register/otp.vue").then(m => m.default || m)
  },
  {
    name: select_45sportQaQNzSsJD6Meta?.name ?? "register-select-sport",
    path: select_45sportQaQNzSsJD6Meta?.path ?? "/register/select-sport",
    meta: select_45sportQaQNzSsJD6Meta || {},
    alias: select_45sportQaQNzSsJD6Meta?.alias || [],
    redirect: select_45sportQaQNzSsJD6Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/register/select-sport.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordJ9ZgVuvK60Meta?.name ?? "reset-password",
    path: reset_45passwordJ9ZgVuvK60Meta?.path ?? "/reset-password",
    meta: reset_45passwordJ9ZgVuvK60Meta || {},
    alias: reset_45passwordJ9ZgVuvK60Meta?.alias || [],
    redirect: reset_45passwordJ9ZgVuvK60Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: add8StPDfLLU0Meta?.name ?? "socials-id-comments-add",
    path: add8StPDfLLU0Meta?.path ?? "/socials/:id()/comments/add",
    meta: add8StPDfLLU0Meta || {},
    alias: add8StPDfLLU0Meta?.alias || [],
    redirect: add8StPDfLLU0Meta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/socials/[id]/comments/add.vue").then(m => m.default || m)
  },
  {
    name: indexhuLsXQ3bwJMeta?.name ?? "socials-id-comments",
    path: indexhuLsXQ3bwJMeta?.path ?? "/socials/:id()/comments",
    meta: indexhuLsXQ3bwJMeta || {},
    alias: indexhuLsXQ3bwJMeta?.alias || [],
    redirect: indexhuLsXQ3bwJMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/socials/[id]/comments/index.vue").then(m => m.default || m)
  },
  {
    name: add_45postExwoq7JM7sMeta?.name ?? "socials-add-post",
    path: add_45postExwoq7JM7sMeta?.path ?? "/socials/add-post",
    meta: add_45postExwoq7JM7sMeta || {},
    alias: add_45postExwoq7JM7sMeta?.alias || [],
    redirect: add_45postExwoq7JM7sMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/socials/add-post.vue").then(m => m.default || m)
  },
  {
    name: indexZFgJj3oZIqMeta?.name ?? "socials",
    path: indexZFgJj3oZIqMeta?.path ?? "/socials",
    meta: indexZFgJj3oZIqMeta || {},
    alias: indexZFgJj3oZIqMeta?.alias || [],
    redirect: indexZFgJj3oZIqMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/socials/index.vue").then(m => m.default || m)
  },
  {
    name: profilesOSBfcd534eMeta?.name ?? "socials-profiles",
    path: profilesOSBfcd534eMeta?.path ?? "/socials/profiles",
    meta: profilesOSBfcd534eMeta || {},
    alias: profilesOSBfcd534eMeta?.alias || [],
    redirect: profilesOSBfcd534eMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/socials/profiles.vue").then(m => m.default || m)
  },
  {
    name: index0UyGoXICNeMeta?.name ?? "tournaments-id",
    path: index0UyGoXICNeMeta?.path ?? "/tournaments/:id()",
    meta: index0UyGoXICNeMeta || {},
    alias: index0UyGoXICNeMeta?.alias || [],
    redirect: index0UyGoXICNeMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/tournaments/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexD2gbiC755jMeta?.name ?? "tournaments",
    path: indexD2gbiC755jMeta?.path ?? "/tournaments",
    meta: indexD2gbiC755jMeta || {},
    alias: indexD2gbiC755jMeta?.alias || [],
    redirect: indexD2gbiC755jMeta?.redirect,
    component: () => import("/root/code-vivasport/vs2-front/pages/tournaments/index.vue").then(m => m.default || m)
  }
]